import React from 'react';
import { usePlatesTimeline } from './hooks';
import { ContextHeader, backendEventToTimelineItem } from './designHelpers';
import DrawerShell from '../insurance/DrawerShell';
import '../insurance/seguros-design.css';

export default function HistoryDrawer({ visible, onHide, plateId, view }) {
  const { events, loading } = usePlatesTimeline(plateId);
  const items = (events || []).map(backendEventToTimelineItem);

  return (
    <DrawerShell visible={visible} onClose={onHide}>
      <div style={{ padding: '22px 26px 16px', borderBottom: '1px solid var(--pei-gray-5)', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ flex: 1 }}>
          <div className="eyebrow" style={{ marginBottom: 6 }}>Paso 6 · Placas</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--pei-text)', letterSpacing: '-0.008em' }}>
            Histórico del paso
          </div>
          <div style={{ fontSize: 12.5, color: 'var(--pei-text-helper)', marginTop: 4 }}>
            {items.length} evento{items.length === 1 ? '' : 's'} · más reciente arriba
          </div>
        </div>
        <button className="modal-close" style={{ position: 'static', flexShrink: 0 }} onClick={onHide}>
          <i className="pi pi-times" />
        </button>
      </div>

      <div style={{ padding: '14px 26px', background: 'var(--pei-bg-soft)', borderBottom: '1px solid var(--pei-gray-5)' }}>
        <ContextHeader cliente={view?.cliente} vehiculo={view?.vehiculo} contrato={view?.contrato} compact />
      </div>

      <div className="scrollable" style={{ flex: 1, padding: '20px 26px' }}>
        {loading && <div style={{ fontSize: 13, color: 'var(--pei-text-helper)' }}>Cargando…</div>}

        {!loading && items.length === 0 && (
          <div style={{
            padding: '40px 20px',
            textAlign: 'center',
            color: 'var(--pei-text-helper)',
            background: 'var(--pei-bg-soft)',
            borderRadius: 12,
            border: '1px dashed var(--pei-gray-5)',
          }}>
            <i className="pi pi-history" style={{ fontSize: 28, color: 'var(--pei-gray-2)', marginBottom: 10, display: 'block' }} />
            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--pei-text-label)' }}>Sin eventos todavía</div>
            <div style={{ fontSize: 12, marginTop: 6 }}>Aparecerán aquí en cuanto inicies el flujo.</div>
          </div>
        )}

        {!loading && items.length > 0 && (
          <div style={{ position: 'relative', paddingLeft: 28 }}>
            <div style={{ position: 'absolute', left: 13, top: 10, bottom: 10, width: 1.5, background: 'var(--pei-gray-5)' }} />
            {items.map((ev, i) => (
              <DrawerEvent key={i} event={ev} first={i === 0} />
            ))}
          </div>
        )}
      </div>

      <div style={{ padding: '14px 26px 22px', borderTop: '1px solid var(--pei-gray-5)', display: 'flex', justifyContent: 'flex-end' }}>
        <button className="pei-btn pei-btn-ring" onClick={onHide}>Cerrar</button>
      </div>
    </DrawerShell>
  );
}

function DrawerEvent({ event, first }) {
  const colorMap = {
    cyan:   { bg: 'rgba(50,184,223,0.16)',  color: 'var(--pei-cyan)' },
    green:  { bg: 'rgba(34,236,154,0.22)',  color: 'var(--pei-green-true)' },
    orange: { bg: 'rgba(255,108,14,0.16)',  color: 'var(--pei-orange)' },
    red:    { bg: 'rgba(220,38,38,0.14)',   color: 'var(--pei-danger)' },
    blue:   { bg: 'rgba(32,75,123,0.12)',   color: 'var(--pei-blue-deeper)' },
  };
  const c = colorMap[event.color] || colorMap.cyan;

  return (
    <div style={{ position: 'relative', marginBottom: 22, marginLeft: -28, paddingLeft: 40 }}>
      <div style={{
        position: 'absolute', left: 0, top: 0,
        width: 28, height: 28, borderRadius: 14,
        background: c.bg, color: c.color,
        display: 'grid', placeItems: 'center',
        border: '2px solid white',
        boxShadow: first ? `0 0 0 4px ${c.bg}` : 'none',
      }}>
        <i className={`pi ${event.icon}`} style={{ fontSize: 13 }} />
      </div>

      <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--pei-text)', lineHeight: 1.4, marginTop: 2 }}>
        {event.title}
      </div>
      {event.sub && (
        <div style={{ fontSize: 12.5, color: 'var(--pei-text-helper)', marginTop: 4, lineHeight: 1.5 }}>
          {event.sub}
        </div>
      )}
      <div style={{ fontSize: 11.5, color: 'var(--pei-text-helper)', marginTop: 6, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <span>{event.time}</span>
        {event.actor && <><span style={{ opacity: 0.5 }}>·</span><span style={{ fontFamily: 'var(--pei-font-mono)' }}>{event.actor}</span></>}
      </div>
    </div>
  );
}
